import { usePipelineStatusQuery } from "#graphql/supergraphHooks";
import type { PipelineStatusQuery } from "#graphql/supergraphTypes";
import type { ApolloError } from "@apollo/client";

export type DocumentDetailStatus = NonNullable<PipelineStatusQuery["pipelineStatus"]>;

export interface UseDocumentDetailResult {
  status: DocumentDetailStatus | null;
  loading: boolean;
  error?: ApolloError;
}

export function useDocumentDetail(documentId: string): UseDocumentDetailResult {
  const { data, loading, error } = usePipelineStatusQuery({
    variables: { documentId },
    fetchPolicy: "cache-and-network",
  });
  return { status: data?.pipelineStatus ?? null, loading, error };
}
